import logIt from "../../../logIt";

/**
Purpose: A static class to keep temporary variables: 1. in memory, 2. in user session
Motivation: This is to avoid declaring global variables in code
Two-In-1 Usage: The extra 'persist' flag in add() will make sure variable values don't get lost and maintain in page reloads
* */
const TempStorageCache = {
    get(key) {
        try {
            if (this[key]) {
                return this[key];
            }
            return sessionStorage.getItem(key);
        } catch (e) {
            logIt(e.message);
        }
    },

    getAndRemove(key) {
        const got = this.get(key);
        this.del(key);
        return got;
    },

    add(key, value, persist /* optional */) {
        try {
            this[key] = value;
            if (persist) {
                sessionStorage.setItem(key, value);
            }
        } catch (e) {
            logIt(e.message);
        }
    },

    del(key) {
        try {
            delete this[key];
            sessionStorage.removeItem(key);
        } catch (e) {
            logIt(e.message);
        }
    }
}
export default TempStorageCache
